module.exports = __webpack_public_path__ + "img/head-phone-read-aloud-light.2156032.svg";